import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '~/context/GlobalContext';
import { Link } from 'react-router-dom';
import { IRoomProps } from '~/types/common';
import classNames from 'classnames';
import { UsersIcon } from '~/components/Icons/Icons';
import styles from '~/componentsPage/HomePage/styles/CloseArea.module.css';

const CloseArea = ({ data, goToChat }: IRoomProps) => {
  const { context, setContext } = useGlobalContext();
  const navigate = useNavigate();

  return (
    <div data-component="CloseArea" className={styles.closeArea}>
      <div
        className={styles.roomButton}
        key={data.id}
        onClick={() => goToChat(data.id)}
      >
        <div className={styles.title}>
          {data.name}
        </div>
        <div className={styles.count}>
          <UsersIcon className={styles.usersIcon}/> 
          <div>{data.usersCount ? data.usersCount : '0'}</div>
        </div>
      </div>
    </div>
  );
};

export default CloseArea;
